import {AuthEvents} from "../../service/security/security-module";
import server from "../../integration/server/server-services";

export default class appStatusController {
    private externalResourcesHealthy = true;

    constructor($scope: angular.IScope, AUTH_EVENTS: AuthEvents, private readonly server: server) {

        $scope.$on(AUTH_EVENTS.AUTH_LOGGED_IN, () => this.checkExternalResourcesHealthy());
        this.checkExternalResourcesHealthy();
    }

    checkExternalResourcesHealthy() {
        const isOK = (response: boolean) => this.externalResourcesHealthy = response;
        this.server.externalResourcesHealthy()
            .then(isOK, isOK);
    }
}
appStatusController.$inject = ['$scope', 'AUTH_EVENTS', 'server'];
